import React from 'react';
import './darkTheme.css';

const Theme = () => (<React.Fragment></React.Fragment>);

export default Theme;